import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import UndoIcon from '@material-ui/icons/Undo';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';

import DataTable from '../DataTable/DataTable';

const styles = () => ({
  paperWidth: {
    width: '750px',
    maxWidth: '750px',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

class TimeClockDialog extends React.Component {
  state = {
    deleteDialog: false,
    currentItem: 0,
    justification: '',
  };

  handleInputChange = (event) => {
    this.setState({ justification: event.target.value });
  };

  handleDeleteClick = (item) => {
    this.setState({ deleteDialog: true, currentItem: item });
  };

  handleDeleteClose = () => {
    this.setState({ deleteDialog: false, justification: '', currentItem: 0 });
  };

  handleDeleteSubmit = (event) => {
    const { timeClock, handleDelete } = this.props;
    const { currentItem, justification } = this.state;
    event.preventDefault();
    const data = {
      justification,
      employeeId: timeClock[currentItem].employee.id,
      timeclockId: timeClock[currentItem].id,
      category: 'REM',
      remake: timeClock[currentItem].remake,
    };

    handleDelete(data);
    this.handleDeleteClose();
  };

  handleStatus = (timeClockUnit) => {
    if (timeClockUnit.remake) {
      if (timeClockUnit.category === 'INS') {
        return 'Adicionado pelo gestor';
      }
      return 'Desconsiderado';
    }
    return 'Válido';
  };

  render() {
    const {
      classes, timeClock, open, onClose, loading, date,
    } = this.props;
    const { deleteDialog, justification, currentItem } = this.state;
    const remake = timeClock.length ? timeClock[currentItem].remake : false;

    const columns = [
      { name: 'time', label: 'Hora' },
      { name: 'type', label: 'Tipo' },
      { name: 'address', label: 'Local' },
      { name: 'status', label: 'Status' },
    ];

    return (
      <React.Fragment>
        <Dialog
          open={open}
          onClose={onClose}
          PaperProps={{ classes: { root: classes.paperWidth } }}
        >
          <DialogTitle>
            <div className={classes.title}>
              Editar pontos
              <Typography align="right" color="textSecondary">
                {date}
              </Typography>
            </div>
          </DialogTitle>
          <DialogContent>
            <DataTable
              rows={timeClock.map((timeClockUnit, index) => ({
                id: index,
                time: moment.utc(timeClockUnit.dtregister).format('HH:mm:ss'),
                type: timeClockUnit.type === 'I' ? 'Entrada' : 'Saída',
                address: timeClockUnit.addresslocation,
                status: this.handleStatus(timeClockUnit),
                actions: [
                  {
                    name: timeClockUnit.remake ? 'Desfazer' : 'Desconsiderar',
                    icon: timeClockUnit.remake ? UndoIcon : DeleteIcon,
                    onClick: (item) => {
                      this.handleDeleteClick(item.id);
                    },
                  },
                ],
              }))}
              columns={columns}
              loading={loading}
              pagination={false}
              independentActions
            />
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={onClose}>
              FECHAR
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={deleteDialog} onClose={this.handleDeleteClose}>
          <DialogTitle>{remake ? 'Desfazer' : 'Desconsiderar'}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {remake
                ? 'Você tem certeza que deseja efetuar esta ação?'
                : 'Preencha o campo com a justificativa da desconsideração do ponto'}
            </DialogContentText>
            {!remake ? (
              <form onSubmit={this.handleDeleteSubmit}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="justification"
                  label="Justificativa"
                  type="text"
                  onChange={this.handleInputChange}
                  value={justification}
                  fullWidth
                  required
                />
              </form>
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteClose}>CANCELAR</Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={!remake && justification.trim() === ''}
              onClick={this.handleDeleteSubmit}
              autoFocus={remake}
            >
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

TimeClockDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  timeClock: PropTypes.array.isRequired,
  handleDelete: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  date: PropTypes.string.isRequired,
};

export default withStyles(styles)(TimeClockDialog);
